var _g, _tspan, _g2, _g3, _tspan2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentBefore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 235 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "axis"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0051,0,0,1.0051,-146.214,-284.005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.92,350.334L363.949,350.334",
    style: {
      fill: "none",
      stroke: "black",
      strokeOpacity: 0.05,
      strokeWidth: "0.99px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-877.16,-66.597)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(13,0,0,13,1095.64,150.104)"
  })), /*#__PURE__*/React.createElement("text", {
    x: "1059.3px",
    y: "150.104px",
    style: {
      fontFamily: "'Aileron-Regular', 'Aileron'",
      fontSize: 13,
      fill: "rgb(183,183,183)"
    }
  }, "T", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: "1066.45px ",
    y: "150.104px "
  }, "o")), "day")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-989.296,-104.452)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(13,0,0,13,1074.72,186.377)"
  })), /*#__PURE__*/React.createElement("text", {
    x: "1003.97px",
    y: "186.377px",
    style: {
      fontFamily: "'Aileron-Regular', 'Aileron'",
      fontSize: 13,
      fill: "rgb(183,183,183)"
    }
  }, "90 days ago"))), /*#__PURE__*/React.createElement("g", {
    id: "content-BEFORE",
    transform: "matrix(1,0,0,1,-0.464732,6.40587)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "content_1",
    transform: "matrix(1,0,0,1,-454.933,-215.624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M473.418,245.7C473.418,245.7 500.139,246.471 531.907,251.54",
    style: {
      fill: "none",
      stroke: "rgb(255,152,0)",
      strokeWidth: "2.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "content_2",
    transform: "matrix(2.12064,0,0,1,-1051.07,-215.624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.965,251.549C542.956,253.904 553.087,255.501 560.754,256.349C574.489,257.869 589.759,257.751 597.334,258.275",
    style: {
      fill: "none",
      stroke: "rgb(255,152,0)",
      strokeWidth: "2.5px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-457.933,-227.624)"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15,0,0,15,677.619,262.41)"
  })), /*#__PURE__*/React.createElement("text", {
    x: "642.594px",
    y: "262.41px",
    style: {
      fontFamily: "'Aileron-Black', 'Aileron'",
      fontWeight: 900,
      fontSize: 15,
      fill: "rgb(255,152,0)"
    }
  }, "F", _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: "651.624px 662.454px 667.389px ",
    y: "262.41px 262.41px 262.41px "
  }, "AIR"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentBefore);
export default __webpack_public_path__ + "static/media/content-before.31fde4e5264bd346ac17a3d8d4e62cf9.svg";
export { ForwardRef as ReactComponent };